export enum Settings {
    lookupThreshold = 'lookupThreshold',
    dropDownHeight = 'dropDownHeight',
    objNumber = 'objNumber',
    unitNumber = 'unitNumber',
    stBookingGridHeight = 'stBookingGridHeight',
    lookupNumberFormat = 'lookupNumberFormat',
    lookupSeparatorFormat = 'lookupSeparatorFormat',
    lookupInfoFormat = 'lookupInfoFormat',
    fieldBorderHeight = 'fieldBorderHeight',
    fieldBorderHoverHeight = 'fieldBorderHoverHeight',
    fieldBorderColor = 'fieldBorderColor',
    formFieldType = 'formFieldType',
    ixCommonRuntime = 'ixCommonRuntime',
    xsp2044Filter = 'xsp2044Filter',
    gridHeaderColor = 'gridHeaderColor',
    gridHeaderTextColor = 'gridHeaderTextColor',
    gridRowColor = 'gridRowColor',
    gridRowTextColor = 'gridRowTextColor',
    gridBordersColor = 'gridBordersColor',
    barsStyle = 'barsStyle',
    compact = 'compact',
    openLookupOnClick = 'openLookupOnClick',
    favoriteNavs = 'favoriteNavs',
}